<template>
  <div class="macroscopic-list">
    <div class="row news-type-tab">
      <el-button
        class="news-type-tab-btn"
        :class="{'news-type-tab-active': item === market}"
        v-for="(item, index) in dateRangeTabs"
        :key="index"
        @click="onTabClick(item)"
      >{{item}}</el-button>
    </div>
    <div class="row news-list-source-filter">
      <div class="total-count">共有{{totalCount}}条相关舆情</div>
      <div class="news-list-source-filter-right">
        <SnDatePicker @timeChange="timeChange"></SnDatePicker>
        <el-select class="select set-vertical-align" v-model="source" @change="onSourceChange" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div>
      <div v-loading="isLoading">
        <div
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10"
        >
          <div v-for="(item, index) in resultData" :key="index" class="row source-box">
            <div class="title-item">
              <a v-if="!item.is_pdf" class="news-title" target="_blank" :href="item.url">{{item.title}}</a>
              <router-link @click.native="toPdfPage(item)" class="news-title" v-else target="_blank" :to="{path: '/pdf-detail'}">
                <span>{{item.title}}</span>
              </router-link>
            </div>
            <div class="source-item row">
              <div class="date">{{item.date}}</div>
              <div class="source">{{item.source}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="loading" v-if="itemData.length && resultData.length && totalCount>pageSize">
        <div class="loading-word">加载中...</div>
      </div>
      <div class="loading" v-if="!itemData.length && resultData.length || (totalCount>0 && totalCount<=pageSize)">
        <div class="loading-word">没有更多了</div>
      </div>
    </div>
    <el-dialog title class="detail-dialog" :visible.sync="dialogVisible" width="800px" top="10vh">
      <div class="detail-dialog-header">
        <div class="title">{{title}}</div>
        <div class="row dialog-date-source">
          <div class="row">
            <div>{{date}}</div>
            <div class="source">{{sources}}</div>
          </div>
          <div class="row">
            <el-switch inactive-color="#d1d2da" v-model="switchStatus"></el-switch>
            <div class="switch-title">线索高亮</div>
          </div>
        </div>
      </div>
      <div
        class="detail-dialog-content content"
        :class="{'detail-dialog-content-highlight': !switchStatus}"
      >
        <div v-html="detail"></div>
      </div>
      <div class="detail-dialog-footer">
        <a class="url" :href="this.url" target="_blank">查看原文</a>
        <div class="warning">注意：点击"查看原文"将跳转至第三方源网站，可能存在原文地址失效无法访问的情况。</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import questionQuery from '@/rest/questionQuery';
import Mark from 'mark.js';
import SnDatePicker from '@/components/common/SnDatePicker';
import localStorageHelper from '@/helpers/localStorageHelper';

export default {
  data() {
    return {
      dateRangeTabs: ['国内宏观', '国际宏观'],
      market: '国内宏观',
      totalCount: 0,
      dialogVisible: false,
      title: '',
      date: '',
      sources: '',
      detail: '',
      negativeHeight: [],
      positiveHeight: [],
      url: '',
      instance: '',
      switchStatus: true,
      source: '全部来源',
      options: [
        {
          value: '全部来源',
          label: '全部来源'
        },
        {
          value: '官媒',
          label: '官媒'
        },
        {
          value: '公众号',
          label: '公众号'
        }
      ],
      earliestNewsId: -1,
      earliestDateNum: -1,
      latestDateNum: -1,
      itemData: [],
      resultData: [],
      busy: false,
      isLoading: false,
      pageSize: 20,
      companyNewsListTimer: null,
      dateRange: []
    };
  },
  methods: {
    toPdfPage(item) {
      localStorageHelper.setItem('PDF_DETAIL_DATA', JSON.stringify(item));
    },
    timeChange(date) {
      this.getLatestMonitorCompanyNewsSetInterval(false);
      this.dateRange = date || [];
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.getFirstNewsListV2();
    },
    onTabClick(res) {
      this.getLatestMonitorCompanyNewsSetInterval(false);
      this.market = res;
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.getFirstNewsListV2();
    },
    onSourceChange(res) {
      this.source = res;
      this.getLatestMonitorCompanyNewsSetInterval(false);
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.getFirstNewsListV2();
    },
    detailFn(item) {
      questionQuery.getNewsDetail(item).then(res => {
        const a = document.createElement('a');
        a.setAttribute('href', res.url);
        a.setAttribute('target', '_blank');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.itemData.length) {
        this.timer = setTimeout(() => {
          this.getNewsListV2();
        }, 500);
      }
    },
    getNewsListV2() {
      const params = {
        sourceGenre: this.source === '公众号' ? '微信' : this.source,
        pageSize: this.pageSize,
        macroEconomy: this.market,
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1,
        date: this.dateRange
      };
      this.isLoading = true;
      questionQuery.macroPublicList(params).then(res => {
        this.isLoading = false;
        this.itemData = res.pageItems;
        this.totalCount = res.totalCount;
        this.busy = false;
        if (this.itemData.length) {
          this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
          this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
          this.resultData = this.resultData.concat(this.itemData);
          this.busy = false;
        } else {
          this.busy = true;
        }
      });
    },
    getFirstNewsListV2() {
      const params = {
        sourceGenre: this.source === '公众号' ? '微信' : this.source,
        pageSize: this.pageSize,
        macroEconomy: this.market,
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1,
        date: this.dateRange
      };
      this.isLoading = true;
      questionQuery.macroPublicList(params).then(res => {
        this.isLoading = false;
        this.itemData = res.pageItems;
        this.totalCount = res.totalCount;
        this.busy = false;
        if (this.itemData.length) {
          this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
          this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
          this.resultData = this.resultData.concat(this.itemData);
          this.latestDateNum = this.resultData[0].dateNum;
          this.busy = false;
        } else {
          this.busy = true;
        }
        this.getLatestMonitorCompanyNewsSetInterval(true);
      });
    },
    getLatestMonitorCompanyNewsSetInterval(start) {
      if (this.companyNewsListTimer) {
        clearTimeout(this.companyNewsListTimer);
      }
      if (start) {
        this.companyNewsListTimer = setTimeout(() => {
          this.getLatestMonitorCompanyNewsList();
          this.getLatestMonitorCompanyNewsSetInterval(start);
        }, 1000 * 20);
      }
    },
    getLatestMonitorCompanyNewsList() {
      const params = {
        sourceGenre: this.source === '公众号' ? '微信' : this.source,
        pageSize: 20,
        macroEconomy: this.market,
        earliestNewsId: -1,
        earliestDateNum: -1,
        latestDateNum: this.latestDateNum,
        date: this.dateRange
      };
      questionQuery.macroPublicList(params).then(res => {
        if (res.pageItems.length) {
          this.latestNewsId = res.pageItems[0].newsId;
          this.latestDateNum = res.pageItems[0].dateNum;
          this.resultData.unshift(...res.pageItems);
        }
      },
      () => {
        this.getLatestMonitorCompanyNewsSetInterval(false);
      });
    }
  },
  components: {
    SnDatePicker
  },
  mounted() {
    this.getFirstNewsListV2();
  },
  updated() {
    const instance = new Mark(document.querySelectorAll('.detail-dialog-content'));
    instance.mark(this.positiveHeight || [], {
      element: 'span',
      className: 'positive-height'
    });
    instance.mark(this.negativeHeight || [], {
      element: 'span',
      className: 'negative-height'
    });
  },
  beforeDestroy() {
    this.getLatestMonitorCompanyNewsSetInterval(false);
  }
};
</script>

<style lang="scss" scoped>
/deep/.detail-dialog {
  .detail-dialog-header {
    padding: 32px 32px 26px;
    min-height: 114px;
    width: 100%;
    background-color: #f7f8fc;
    .title {
      margin-bottom: 12px;
      color: #171f46;
      font-size: 20px;
      font-weight: 500;
    }
    .dialog-date-source {
      line-height: 20px;
      justify-content: space-between;
      color: #747990;
      font-size: 12px;
      font-weight: 500;
      .source {
        margin-left: 16px;
      }
      .switch-title {
        margin-left: 8px;
        color: #464d6c;
      }
    }
  }
  .detail-dialog-content {
    padding: 24px 32px;
    height: 496px;
    overflow: auto;
    color: #464d6c;
    font-size:14px;
    line-height: 22px;
    background-color: #ffffff !important;
  }
  .detail-dialog-content-highlight span.positive-height{
    color: #464d6c !important;
  }
  .detail-dialog-content-highlight span.negative-height{
    color: #464d6c !important;
  }
  .detail-dialog-footer {
    padding: 16px 32px;
    background-color: #f7f8fc;
    .url {
      color: #45a8cc;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
    }
    .warning {
      margin-top: 4px;
      color: #747990;
      font-size: 12px;
    }
  }
  .el-dialog {
    background-color: #ffffff;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 680px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}
.macroscopic-list {
  padding: 16px 24px;
  background-color: #ffffff;
  .news-type-tab {
    height: 26px;
    .news-type-tab-btn {
      height: 26px;
      width: 80px;
      margin-left: 0;
      margin-right: 10px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      color: #747990;
      background-color: #f7f8fc;
      font-weight: 400;
      &:hover {
        color: #747990;
        background-color: #eaebef;
      }
      &:focus {
        color: #747990;
        background-color: #eaebef;
      }
      &:active {
        color: #747990;
        background-color: #eaebef;
      }
    }
    .news-type-tab-active {
      color: #ffffff;
      background-color: #45a8cc;
      font-weight: 400;
      &:hover {
        color: #ffffff;
        background-color: #3e97b8;
      }
      &:focus {
        color: #ffffff;
        background-color: #3e97b8;
      }
      &:active {
        color: #ffffff;
        background-color: #3e97b8;
      }
    }
  }
  .news-list-source-filter {
    justify-content: space-between;
    margin-top: 16px;
    width: 100%;
    height: 48px;
    line-height: 48px;
    border-top: 1px solid #f7f7fa;
    border-bottom: 1px solid #f7f7fa;
    .total-count {
      color: #747990;
      font-size: 12px;
    }
    .news-list-source-filter-right {
      .clues-show-btn {
        height: 26px;
        width: 80px;
        padding: 0;
        border-radius: 4px;
        border: none;
        font-size: 14px;
        font-weight: 400;
        color: #747990;
        background-color: #f7f7fa;
        &:hover {
          color: #747990;
          background-color: #f7f7fa;
        }
        &:focus {
          color: #747990;
          background-color: #f7f7fa;
        }
        &:active {
          color: #747990;
          background-color: #f7f7fa;
        }
      }
      .select {
        margin-left: 10px;
        width: 100px;
      }
    }
  }
  .source-box {
    width: 100%;
    justify-content: space-between;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -1px 0px 0px rgba(247, 247, 250, 1);
    line-height: 54px;
    color: #171f46;
    .title-item{
      width: 700px;
      line-height: 22px;
      padding: 14px 0;
    }
    .source-item {
      color: #747990;
      font-size: 12px;
      .date {
        margin-right: 16px;
      }
    }
    .news-title {
      margin: 0 24px 8px 0;
      color: #171f46;
      font-size: 16px;
      font-weight: 500;
      text-decoration: none;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
  }
  .loading {
    padding: 12px 0;
    margin: 0 auto;
    height: 10px;
    width: 772px;
    color: #666666;
    text-align: center;
  }
}
/deep/.el-select .el-input__inner {
  height: 26px;
  border: none !important;
  border-radius: 2px;
  color: #464D6C;
  background-color: #f7f8fc !important;
  &:hover {
    background-color: #eaebef !important;
  }
}
/deep/.el-select .el-input .el-select__caret {
  font-weight: 900;
  color: #747990;
}
</style>
